const httpStatus = {
  OK: 200,
  CREATED: 201,
};

export default httpStatus;
